import PaymentStepper from "../views/payment/index.vue";

const menu = [
  {
    title: "Оплата доступа",
    icon: "fa fa-money-bill-alt",
    url: "/payment",
    id: 6,
  },
];

const routes = [
  {
    path: "/payment",
    name: "payment",
    component: PaymentStepper,
    meta: {
      forAuth: true
    }
  }
];

export default { menu, routes };
